export const getInitials = (nameString) => {
  const regexChar = /\D\w+/;

  return nameString
    .trim()
    .split(" ")
    .filter((word) => word.length > 0)
    .filter((word) => regexChar.test(word))
    .map((word) => word.substring(0, 1).toUpperCase());
};

export const lowerCaseFirstLetter = (string) => string.charAt(0).toLowerCase() + string.slice(1);
